import { render, staticRenderFns } from "./VotingResults.vue?vue&type=template&id=35e93f24"
import script from "./VotingResults.vue?vue&type=script&lang=js"
export * from "./VotingResults.vue?vue&type=script&lang=js"
import style0 from "./VotingResults.vue?vue&type=style&index=0&id=35e93f24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports